import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';

import { environment } from '../environments/environment';

import { GoogleAnalyticsEventsService } from './_core/services/google-analytics-events.service';
import { LoadingService } from './_core/services/loading.service';
import { ProfileService } from './_core/services/profile.service';
import { AuthService } from './auth/auth.service';

declare let gtag: Function;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class AppComponent {
  loading = false;

  constructor(
    private readonly loadingService: LoadingService,
    private readonly profileService: ProfileService,
    private readonly route: ActivatedRoute,
    private readonly router: Router,
    public authService: AuthService,
    private readonly cdr: ChangeDetectorRef
  ) {
    this.addGAScript();
    this.loadingService.onLoadingChanged.subscribe((isLoading) => {
      this.loading = isLoading;
      this.cdr.detectChanges();
    });
  }

  onRouterActivate() {
    const routeConfig = this.route.snapshot.root.firstChild.routeConfig;
    this.profileService.routeConfigPath = routeConfig.path;
  }

  /**
   * Setup Google Tag Manager
   */
  private addGAScript(): void {
    const gaIdApp = environment.gaId;
    const cspNonce = document.getElementsByTagName('body')[0].getAttribute('data-nonce');

    const gtagScript: HTMLScriptElement = document.createElement('script');
    gtagScript.async = true;
    gtagScript.src = 'https://www.googletagmanager.com/gtag/js?id=' + gaIdApp;
    gtagScript.setAttribute('nonce', cspNonce);
    document.head.appendChild(gtagScript);

    const gaScript = document.createElement('script');
    gaScript.innerHTML = `
      window.dataLayer = window.dataLayer || [];
      function gtag() { dataLayer.push(arguments); }
      gtag('consent', 'default', {
        'ad_user_data': 'denied',
        'ad_personalization': 'denied',
        'ad_storage': 'denied',
        'analytics_storage': 'granted'
      });
      gtag('js', new Date());
    `;
    gaScript.setAttribute('nonce', cspNonce);
    document.head.appendChild(gaScript);

    GoogleAnalyticsEventsService.setupID(gaIdApp);
    if (!GoogleAnalyticsEventsService.gaOff) {
      this.router.events.subscribe((event) => {
        if (event instanceof NavigationEnd) {
          GoogleAnalyticsEventsService.emitUrl(event.urlAfterRedirects);
        }
      });
    }
  }
}
